module.exports = __webpack_public_path__ + "img/service-juece2.f3db2466.svg";